<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Open cash report'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Cash'|translate}}</mat-label>
                    <input matInput formControlName="openDayCash" required (input)="commentsRequired()">
                    <mat-error>{{'Cash is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Comments'|translate}}</mat-label>
                    <textarea matInput formControlName="comments" [required]="areCommentsRequired"></textarea>
                    <mat-hint *ngIf="areCommentsRequired">{{'Comments are required when provided cash is different than calculated.'|translate}}</mat-hint>
                    <mat-error *ngIf="lastCashReport">{{'Provided cash value is different than calculated. Add comments!'|translate}} ({{lastCashReport.cash}} != {{form.get('openDayCash').value}})</mat-error>
                </mat-form-field>
            </div>


        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="save-button"
                (click)="matDialogRef.close(form)"
                [disabled]="form.invalid"
                aria-label="Save">
            {{'Open'|translate}}
        </button>

    </div>
</div>
